<template>
  <div >
    <div class="innerContainer block">
      <div class="message">
        <h3>
         {{ t('ACOMPANHAR_PEDIDO') }}
        </h3>
        <img src="../assets/img/pedido-confirmacao.gif">
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.message{
    display: inline-block;
    width: 100%;
    text-align: center;
    span{
      padding-right:16%;
    }
    img{ 
        width: 100%;
    }
}
@media screen and (min-width: 767px) {  
  .message{
    display: inline-block;
    width: 60%;
    text-align: center;
    margin: 5% 21%;
    img{
        width: 100% !important;
    }
    span{
      padding-right: 0;
    }
  }
}
</style>

<script>
import { redirect } from '../helpers/helpers'
import { translate } from '../services/translate.service';
export default {
  name: 'telanova',
  components: {
  },
  methods: {
    t:translate
  }
}
</script>
